import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../actions';
import LineBlocking from './LineBlocking';

/**
 * @namespace Blocking
 * @extends Component
 * @classdesc (Component) This is the parent Blocking component that handles
 * the UI and the saving of Blocks.
 * @prop {number} blockID - (local) Keeps track of the block number
 * @prop {object} data - (prop) Standard data pulled from database on lesson
 * used in Line Blocking
 * @prop {array} text - (state) Text of the poem in strings
 * @prop {object} blocking - (state) state associated with blocking
 * @prop {object} entries - (state) previously submitted blocks
 */
class Blocking extends Component {

  constructor(props){
    super(props);
    this._blockID = 0;
  }

  /** Getter passed down to < LineBlocking/> */
  getBlockID() {
    return this._blockID;
  }

  /** Used to reset the marked blocks in state */
  componentWillUnmount(){
    this.props.resetBlocks();
  }

  /** When mounts, use action to load the marked blocks from entries */
  componentWillMount(){
    if(this.props.entries.marked)
      this.props.loadMarked(this.props.entries);
  }

  /**
  * Passed to LineBlocking to increment
  * the blockID property by one.
  * @returns {number} blockID + 1
  */
  nextBlock(){
    this._blockID = this._blockID + 1;
  }

  /**
  * Renders LineBlocking component with
  * correct blockID and action object filled
  * with needed state callbacks
  * @returns {object} < LineBlocking />
  */
  renderLines() {
    /**
     * Collection of callbacks passed to < LineBlocking/> :
     * addMarked, removeMarked, toggleHover, nextBlock
     * @memberof Blocking
     */
    const actions = {
      addMarked: this.props.addMarked,
      removeMarked: this.props.removeMarked,
      toggleHover: this.props.toggleHover,
      nextBlock: () => this.nextBlock()
    };

    //Create linebreaks denoted by ''
    return this.props.text.lines.map(function(words, key){
      if(words === '') return <li key={'break_' + key}>&nbsp;</li>;

      return (
        <LineBlocking
          key = {'line_' + key}
          lineNum = {key + 1}
          words={words.split(' ')}
          actions = {actions}
          blockState = {this.props.blocking}
          getBlockID = {this.getBlockID.bind(this)}
        />
      )
    }, this);
  }

  /** Uses the renderLines method to output the blockable lines */
  render(){
    return (
      <div id="Blocking">
        <ul className = "poem">
          <li className="title"><h2>{this.props.text.title}</h2></li>
          {this.renderLines()}
        </ul>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    text: state.course.text,
    blocking: state.blocking,
    entries: state.entries.blocks
  };
}

export default connect(mapStateToProps, actions)(Blocking);



// WEBPACK FOOTER //
// ./src/components/Blocking/Blocking.js